import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { API_URL, URLS } from "../../_config"
import toast from "react-hot-toast";
import Error from "../../components/formFieldError";
import { Controller, useForm } from "react-hook-form";
import { APP_NAME, LOGO_URL } from "../../_config/site_urls";

const SignUp = () => {
    const navigate: any = useNavigate();
    const { control, formState: { errors }, handleSubmit, setError } = useForm();
    // Referral code is now captured globally in App.tsx (AffiliateTracker) and stored
    // in localStorage when the user lands on any page via a /go/{shortcode} link.
    // It is read here at submission time and cleared after successful registration.

    const submitSignUp = (params: any) => {
        return new Promise((resolve, reject) => {
            fetch(API_URL.AUTH.SIGN_UP, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            })
                .then(response => response.json())
                .then(resp => {
                    if (resp?.status == 200) {
                        // Handle success
                        console.log('Response:', resp);
                        resolve(resp.message);
                    } else {
                        reject(resp.message);
                        const errorResp = resp?.data;
                        console.log('Error Response Data:', errorResp);
                        if (errorResp) {
                            if(errorResp.hasOwnProperty('email')) {
                                // console.log('Email Error:', errorResp['email'][0]);
                                setError('email', {
                                    // type: "manual",
                                    message: errorResp['email'][0]
                                });
                            }else{
                                Object.keys(errorResp).map((key) => {
                                    setError(key, {
                                        type: "manual",
                                        message: errorResp[key]
                                    })
                                })

                            }
                        }
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error('Error:', error);
                    reject(error.message);
                });
        })
    }


    const saveFormHandler = async (data: any) => {
        // Read affiliate ref from session cookie (set by AffiliateTracker in App.tsx)
        const cookieMatch = document.cookie.match(/(?:^|;\s*)affiliate_ref=([^;]*)/);
        const affiliateRef = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
        if (affiliateRef) {
            data.referral_code = affiliateRef;
        }
        toast.promise(
            submitSignUp(data), {
            loading: 'Submitting...',
            success: (msg: any) => {
                localStorage.setItem("loginEmail", data.email);
                // Delete affiliate_ref session cookie after successful registration
                document.cookie = 'affiliate_ref=; path=/; max-age=0; SameSite=Lax';
                navigate(URLS.LOGIN);

                return <b>{msg}</b>
            },
            error: (msg: any) => { return <b>{msg}</b> },
        });
    }


    return (
        <React.Fragment>
            <div className="login-bg"></div>
            <div className="login-box">
                <div className="login-box-left">
                    <Link to={URLS.HOME} className="logo-login"><img className="nav-logo" src={LOGO_URL} alt={APP_NAME} /></Link>
                    <div className="login-text" data-aos="fade-up">
                        <h2>Hey There!</h2>
                        <p>Welcome Back.</p>
                        <p>You are just one step away to your feed</p>
                    </div>
                    <div className="sign-up-box" data-aos="fade-up">
                        <h3>You already have an account?</h3>
                        <Link className="outline-btn-plan-craft" to={URLS.LOGIN}>Log In</Link>
                    </div>
                </div>
                <div className="login-box-right">
                    <h2>Sign-up to <span>PlanCrafter</span></h2>
                    <p>Enter your details please</p>
                    <div data-aos="fade-up" className="form-wrap">
                        <form onSubmit={handleSubmit(saveFormHandler)} className="col-md-12 row">
                            <div className="col-lg-6 col-md-12 mb-3 float-input">
                                <label className="form-label">First Name <span className="text-danger">*</span></label>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    name={`first_name`}
                                    rules={{ required: "First name is required." }}
                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Enter first name" spellCheck="false" data-ms-editor="true" />
                                    )}
                                />
                                <Error error={errors[`first_name`]} customClass="text-xs" />
                            </div>
                            <div className="col-lg-6 col-md-12 mb-3 float-input">
                                <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    name={`last_name`}
                                    rules={{ required: "Last name is required." }}
                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Enter last name" spellCheck="false" data-ms-editor="true" />
                                    )}
                                />
                                <Error error={errors[`last_name`]} customClass="text-xs" />
                            </div>

                            <div className="col-lg-6 col-md-12 mb-3 float-input">
                                <label className="form-label">Email <span className="text-danger">*</span></label>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    name={`email`}
                                    rules={{
                                        required: "Email is required.", pattern: {
                                            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                            message: "Invalid email address.",
                                        }
                                    }}
                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="name@example.com" spellCheck="false" data-ms-editor="true" />
                                    )}
                                />
                                <Error error={errors[`email`]} customClass="text-xs" />
                            </div>
                            <div className="col-lg-6 col-md-12 mb-3 float-input">
                                <label className="form-label">Phone <span className="text-danger">*</span></label>
                                {/* <Controller
                                    defaultValue={""}
                                    control={control}
                                    name={`phone`}
                                    rules={{ required: "Phone is required." }}
                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Enter phone" spellCheck="false" data-ms-editor="true" />
                                    )}
                                /> */}
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: "Phone is required.",
                                        pattern: {
                                            value: /^[0-9]{10}$/, 
                                            message: "Phone number must be 10 digits."
                                        }
                                    }}
                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                        <input
                                            type="text"
                                            name={name}
                                            onChange={(e) => {
                                                const newValue = e.target.value.replace(/[^0-9]/g, ''); 
                                                onChange(newValue);
                                              }}
                                            value={value}
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder="Enter phone"
                                            spellCheck="false"
                                            data-ms-editor="true"
                                            maxLength={10} // This ensures no more than 10 characters can be entered
                                        />
                                    )}
                                />

                                <Error error={errors[`phone`]} customClass="text-xs" />
                            </div>
                            <button type="submit" className="primary-btn-plan-craft w-100">Sign Up</button>
                        </form>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default SignUp